import { Spinner as FluentSpinner } from '@fluentui/react-components';

interface SpinnerProps {
  size?: 'tiny' | 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'huge';
  label?: string;
}

export function Spinner({ size = 'medium', label }: SpinnerProps) {
  return <FluentSpinner size={size} label={label} />;
}
